import { Projects as ProjectsModule } from '@/shared/components';

import { USER_DASHBOARD_AMPLITUDE_PAGE_NAME } from '../../constants';
import {
  ENROLLMENTS_COURSES_ROUTE,
  ENROLLMENTS_DEGREES_ROUTE,
  ENROLLMENTS_ROUTE,
} from '../config';

const Projects = () => (
  <ProjectsModule
    amplitudePageName={USER_DASHBOARD_AMPLITUDE_PAGE_NAME}
    enrollmentsCoursesRoutePath={ENROLLMENTS_COURSES_ROUTE.path}
    enrollmentsDegreesRoutePath={ENROLLMENTS_DEGREES_ROUTE.path}
    enrollmentsRoute={ENROLLMENTS_ROUTE.path}
  />
);

export default Projects;
